import { Link } from 'gatsby'
import PropTypes from 'prop-types'
import React, { Fragment } from 'react'
import { Heading, Container, Box, Flex, Link as MagicLink } from '@magicsoup.io/stock'
import { Menu, P, Img } from '../../styled'

import AppIcon from '../../images/logo.svg'

const Header = ({ siteTitle, props }) => (
  <Menu>
    <Container width='100%'>
      <Flex 
        justifyContent='center'
        flexWrap='wrap'
        alignItems='center'>
        <Img src={AppIcon} width="128px" p={[2]}/>
      </Flex>
    </Container>
  </Menu>
)

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
}

export default Header
